<template>
    <div>
        <div class="page-title">Request from Applicant</div>
        <div class="page-box">
            <div class="page-box-title">
                <el-button type="primary" @click="show3 = !show3">Filter</el-button>
            </div>
            <div class="search-box">
                <el-collapse-transition>
                <el-form label-width="80px" v-show="show3" :model="formLabelAlign">
                    <el-form-item label="Status">
                          <el-select v-model="formLabelAlign.status" placeholder="">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="warning" @click="onSubmit">Search</el-button>
                        <el-button icon="el-icon-refresh-left" @click="onReset">Reset</el-button>
                    </el-form-item>
                </el-form>
                </el-collapse-transition>
            </div>
            <el-table
            :data="tableData"
            style="width: 100%;">
                <el-table-column
                    prop="applicationForm.registrationNo"
                    label="Reg. No."
                    >
                </el-table-column>
                 <el-table-column  label="Applicant Name">
                     <template slot-scope="{row}">
                          <span v-if="row.applicationForm">{{JSON.parse(row.applicationForm.applicantName).en}}</span>
                     </template>
                 </el-table-column>
                <el-table-column
                    prop="user.email"
                    label="Email Address"
                    >
                </el-table-column>
                <el-table-column
                    prop="applicationForm.eventStatus.title"
                    label="Event"
                    >
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="Account Status">
                    <template slot-scope="{row}">
                          <span v-if="row.user">{{row.user.status | accountStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="detail"
                    label="Request Detail">
                </el-table-column>
                <el-table-column
                    prop="createdAt"
                    label="Request Date">
                    <template slot-scope="{row}">
                         <span>{{row.createdAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Action">
                    <template slot-scope="{row}">
                         <el-button v-if="row.status == 0" type="warning" @click="onSolved(row.id)">Solved</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {getRequestsFromApplications,solvedRequest} from '@/api/admin/application'
    export default {
        data() {
            return {
                show3:true,
                options:[
                    {
                        label:'Archived',
                        value:1,
                    },
                    {
                        label:'New Request',
                        value:0,
                    },
                ],
                tableData:[],
                activeName: 'first',
                formLabelAlign: {
                    status:null
                }
            }
        },
        created(){
            this.getRequestsFromApplications()
        },
        methods:{
            onReset(){
                this.formLabelAlign.status = null
                this.getRequestsFromApplications()
            },
            onSubmit(){
                this.getRequestsFromApplications()
            },
            onSolved(id){
                this.solvedRequest(id)
            },
            solvedRequest(id){
                solvedRequest(id).then(()=>{
                     this.$message.success('Solved Success!')
                     this.getRequestsFromApplications()
                })
            },
            getRequestsFromApplications(){
                getRequestsFromApplications(this.formLabelAlign).then((v)=>{
                   this.tableData = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding-top: 20px;
    margin-bottom: 30px;
}
.search-box{
    width: 900px;
    margin: auto;
}
.page-box-title{
    display: flex;
    border-bottom: 1px solid #707070;
    justify-content: space-between;
    padding: 0 47px;
    padding-top:46px;
    padding-bottom: 27px;
    margin-bottom: 27px;
}
.el-button--primary {
    width: auto;
    background-color:  #060C60;
    border-color: #060C60;
    font-size: 20px;
    font-weight: bold;
  }
</style>